/*
  src/redux/answers/actions.js

  Created by Justin Chang on 6/15/2017.
*/

import values from 'lodash/values';
import callAPI from '../callAPI';

import {
  SET_ENGAGEMENT_ANSWER,
  SET_ENGAGEMENT_ANSWER_SENT_TO_API
} from './constants';
import {logAmplitudeCompletedCampaignEvent} from "../../amplitude";


// Defaults
const defaultEngagementAnswer = {
  answer: null,
  campaignId: null,
  engagementId: null
};

export function addEngagementAnswer(answer=defaultEngagementAnswer) {
  return (dispatch, _) => {
    /* Verify answer has:
        answer
        campaignId
        engagementId
    */
    if (answer.answer === undefined
        || answer.answer === null
        || answer.answer.length === 0)
        throw new Error('Engagement answer must include an answer.');
    if (answer.campaignId === undefined
        || answer.campaignId === null
        || answer.campaignId.length === 0)
        throw new Error('Engagement answer must include a campaign id.');
    if (answer.engagementId === undefined
        || answer.engagementId === null
        || answer.engagementId.length === 0)
        throw new Error('Engagement answer must include an engagement id.');

    dispatch({
      type: SET_ENGAGEMENT_ANSWER,
      payload: answer
    });
  }
}

export function removeEngagementAnswer(campaignId, engagementId) {
  return (dispatch, _) => {
    if (campaignId === undefined || campaignId === null)
      throw new Error('Removing engagement answers requires a campaign id.');
    if (engagementId === undefined || engagementId === null)
      throw new Error('Removing engagement answers requires an engagement id.');

    dispatch({
      type: SET_ENGAGEMENT_ANSWER_SENT_TO_API,
      payload: {
        campaignId,
        engagementId
      }
    });
  }
}

function getEngagementAnswers(answers, campaignId) {
  const finalEngAnswers = [];
  const engagementAnswers = values(answers); // turn object of objects into array of objects

  for (let i=0; i < engagementAnswers.length; i++) {
    let e = engagementAnswers[i];

    // Validate Engagement Answers
    if (e.sentToApi)
      continue;
    if (e.engagementId === undefined || e.engagementId === null)
      continue;
    if (e.answer === undefined || e.answer === null)
      continue;

    finalEngAnswers.push({
      answer: e.answer,
      engagementId: e.engagementId,
      campaignId: e.campaignId || campaignId,
      timeSpent: e.duration
    });
  }

  return finalEngAnswers;
}

/*
  Sends Engagement Answers to Adjoy API

  @params
        campaignId   <String>
        answers      <Array<Object>>
*/
export function postEngagementAnswers(campaignId) {
  return (dispatch, getState) => {
    const answers = getState().answers[campaignId];

    if (answers) {
      const finalEngagementAnswers = getEngagementAnswers(answers, campaignId);
      let timeSpent = 0;
      Object.keys(answers).forEach((key) => {
        let e = answers[key];
        if (e.duration
          && !isNaN(e.duration)
          && e.duration > 0)
        {
          timeSpent += e.duration;
        }
      });

      console.debug("timeSpent = " + timeSpent)

      if (finalEngagementAnswers.length > 0) {
        return callAPI({
          method: 'POST',
          path: '/app/v1/user/campaignCompletion',
          body: {
            responses: finalEngagementAnswers,
            timeSpent: timeSpent
          },
          skipTimeout: true,
        })(dispatch, getState)
        .then((res) => {

          if (res && res.campaignId) { // if (res && res.code && res.code === 200)
            finalEngagementAnswers.forEach(({ campaignId, engagementId }) => {
              dispatch({
                type: SET_ENGAGEMENT_ANSWER_SENT_TO_API,
                payload: {
                  campaignId: campaignId,
                  engagementId: engagementId
                }
              })
            });

            const campaigns = getState().campaigns;
            const campaign = (campaigns && Array.isArray(campaigns))
              ? campaigns.find(c => c.id === campaignId)
              : false;
            if (campaign) {
              logAmplitudeCompletedCampaignEvent(campaign.name, campaign.totalValue)
            }
          }

          return res;
        })
        .catch(err => {
          console.error('Failed to save engagement answers to API.');
          console.error(err);
        });
      }
    }

    return;
  }
}



/*
  Post all answers with properties:
    - answer
    - engagementId
    - campaignId
*/
export function postAllEngagementAnswers() {
  return (dispatch, getState) => {
    const answers = getState().answers;

    Object.keys(answers).forEach(campaignId => {
      postEngagementAnswers(campaignId)(dispatch, getState);
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/answers/actions.js